module.exports = __webpack_public_path__ + "img/y-255.e9bca394.png";